import React, { useContext } from "react";
import { Program } from "../../../../../config/config";
import { ProcessContext } from "../../../../../contexts/ProcessContext";
import GDPROptinsDialog from "../shared/components/GDPROptinsDialog/GDPROptinsDialog";
import useGDPRHandler from "../shared/hooks/useGDPRHandler";
import { useLoanApplication } from "../shared/hooks/useLoanApplication";
import { useLoanCalculator } from "../shared/hooks/useLoanCalculator/useLoanCalculator";
import { SummaryAndAdjustWrapper } from "../shared/components/SummaryAndAdjustWrapper/SummaryAndAdjustWrapper";
import { CreditLineWithPurchaseConditions } from "./components/CreditLineWithPurchaseConditions";
import { CreditLineConditions } from "./components/CreditLineConditions";
import { FullScreenLoading } from "../BorrowerSelectionLoanSummary/_shared/components/FullScreenLoading";

export function CreditLineSummary() {
  const {
    state: { loan, participant },
  } = useContext(ProcessContext);

  const { submitOptInsConsents, optInsArray, areOptInsSynced } =
    useGDPRHandler();

  const {
    termMarks,
    minTerm,
    maxTerm,
    loanConditions,
    patchSetLoanCalculator,
    setLoanConditionsByTerm,
    loadingLoanCalculators,
  } = useLoanCalculator();

  const {
    handleRequestLoanOrShowOptinsDialog,
    acceptTerms,
    getValues,
    form,
    showOptinsDialog,
    setShowOptinsDialog,
  } = useLoanApplication({
    submitOptInsConsents,
    optInsArray,
    areOptInsSynced,
    patchSetLoanCalculator,
  });

  const handleLoanTermSlider = (event, value) => {
    setLoanConditionsByTerm(value);
  };

  const principalAmount = loan.loan_conditions.principal.amount;
  const programName = loan.loan_conditions?.program.name;

  if (loadingLoanCalculators) {
    return <FullScreenLoading textId="LOADING_LOAN_CONDITIONS" />;
  }

  return (
    <>
      {showOptinsDialog ? (
        <GDPROptinsDialog
          participant={participant}
          form={form}
          showOptinsDialog={showOptinsDialog}
          acceptTerms={acceptTerms}
          optInsArray={optInsArray}
          areOptInsSynced={areOptInsSynced}
          setShowOptinsDialog={setShowOptinsDialog}
        />
      ) : (
        <SummaryAndAdjustWrapper
          termMarks={termMarks}
          minTerm={minTerm}
          maxTerm={maxTerm}
          getValues={getValues}
          loanConditions={loanConditions}
          handleLoanTermSlider={handleLoanTermSlider}
          handleRequestLoanOrShowOptinsDialog={
            handleRequestLoanOrShowOptinsDialog
          }
          ConditionsComponent={
            programName === Program.NO_PURCHASE ? (
              <CreditLineConditions principalAmount={principalAmount} />
            ) : (
              <CreditLineWithPurchaseConditions
                loanConditions={loanConditions}
              />
            )
          }
        />
      )}
    </>
  );
}
